import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Update content tier (free/premium)
 * Key logic: Auto-creates subscription tier with default price (€9.99) on first premium content
 */
export const updateContentTierRpcContract = rpcContract({
  name: "update-content-tier",
  paramsSchema: v.object({
    contentType: v.picklist(["post", "link"]),
    contentId: v.string(),
    tier: v.picklist(["free", "premium"]),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    contentId: v.string(),
    tier: v.picklist(["free", "premium"]),
    tierCreated: v.boolean(),
    tierId: v.optional(v.string()),
    // Price in cents that was auto-assigned (999 = €9.99)
    defaultPriceAssigned: v.optional(v.number()),
  }),
});

export type UpdateContentTierParams = v.InferOutput<(typeof updateContentTierRpcContract)["paramsSchema"]>;
export type UpdateContentTierResult = v.InferOutput<(typeof updateContentTierRpcContract)["resultSchema"]>;
